import { rmmCreateDescription as description } from './description';
import { addAlert as execute } from './execute';

export { description, execute };
